// extracted by mini-css-extract-plugin
export default {"container":"region-overview_container__E8uTB","title":"region-overview_title__C5YQR","header":"region-overview_header__jbUst"};